import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { mapValues } from 'remeda';

import { GridColumnsSettingsDrawer } from '../../../EntitiesGrid';
import { dailyTasksColumnsState, useSetColumns } from '../../state/dailyTasks';

const getColumnsNamesTexts = (t: TFunction<'translation'>) => {
  const textsKeys = {
    startDatetime: 'start-datetime',
    endDatetime: 'end-datetime',
    title: 'title',
    description: 'description',
    responsible: 'responsible',
    userFunction: 'function',
    status: 'status',
    resolutionLevel: 'resolution-level',
    comments: 'comments',
    location: 'location',
    resolvedDate: 'resolved-date',
    participants: 'participants',
    relation: 'relations',
  };

  return mapValues(textsKeys, (key) => t(key));
};

export const DailyTasksColumnsSettingsDrawer = () => {
  const { execute: setColumns } = useSetColumns();
  const { t } = useTranslation();
  return (
    <GridColumnsSettingsDrawer
      setColumns={setColumns}
      columnsState={dailyTasksColumnsState}
      columnsNameTexts={getColumnsNamesTexts(t)}
    />
  );
};
